import type { Locale } from 'date-fns';
import { formatInstantDate } from './format-instant';
import { formatPayloadDate } from './format-payload-date';
import { parseInstant, parsePayloadDate } from './parse-payload-date';

type FormatDateOptions = {
  date: string;
  formatString?: string;
  locale?: Locale;
};

const DEFAULT_FORMAT = 'dd/MM, HH:mm';

/** Renders a payload calendar date as it was sent, in any shopper timezone. */
export function formatDate({
  date,
  formatString = DEFAULT_FORMAT,
  locale,
}: FormatDateOptions): string {
  return formatPayloadDate(parsePayloadDate(date), formatString, { locale });
}

/** Renders a payload timestamp in the shopper's timezone. */
export function formatInstant({
  date,
  formatString = DEFAULT_FORMAT,
  locale,
}: FormatDateOptions): string {
  return formatInstantDate(parseInstant(date), formatString, { locale });
}
